import React, { useEffect, useState } from 'react'
import { api } from '../../api'
import { path } from '../../constants'

export default function Dashboard() {
    const [dashboard, setDashboard] = useState({})
    useEffect(() => {
        api.get(path.dashboard).then(response => {
            let data = response.data
            if(data.success){
                setDashboard(data.data)
            }
        })
    }, [])
  return (
    <div className='flex flex-col gap-5 h-full w-full'>
        <div className='bg-white rounded-md w-full flex flex-col p-3'>
            <h2 className='text-black text-[15px] font-bold'>Dashboard</h2>
        </div>
        <div className='w-full flex items-center gap-4'>
            <div className='bg-white rounded-md p-6 flex flex-col gap-1 flex-1 items-center'>
                <h1 className='text-black font-bold text-[25px] leading-none'>{dashboard.courses}</h1>
                <p className='text-[13px] text-black'>Courses</p>
            </div>
            <div className='bg-white rounded-md p-6 flex flex-col gap-1 items-center flex-1'>
                <h1 className='text-black font-bold text-[25px] leading-none'>{dashboard.users}</h1>
                <p className='text-[13px] text-black'>Users</p>
            </div>
            <div className='bg-white rounded-md p-6 flex flex-col gap-1 items-center flex-1'>
                <h1 className='text-black font-bold text-[25px] leading-none'>{dashboard.instructors}</h1>
                <p className='text-[13px] text-black'>Instructors</p>
            </div>
            <div className='bg-white rounded-md p-6 flex flex-col gap-1 items-center flex-1'>
                <h1 className='text-black font-bold text-[25px] leading-none'>{dashboard.enrolls}</h1>
                <p className='text-[13px] text-black'>Enrollments</p>
            </div>
        </div>
    </div>
  )
}
